<template>
  <div class="cursor-pointer" @click="showBody = !showBody">
    <div class="flex items-center gap-2">
      <div class="text-sm">
        <div class="font-medium text-gray-900">Email - {{ email.subject || 'No subject' }}</div>
      </div>
    </div>
    <div>
      <div v-if="showBody" class="mt-1 text-sm text-gray-700 user-generated-content">
        <div v-html="sanitize(email.body)"></div>
      </div>
      <div class="mt-2 space-x-2 text-sm flex">
        <span class="font-medium text-gray-500"
          >{{ fromNow(email.created_at) }} ago from {{ email.user.name ? email.user.name : email.user.email }}</span
        >
        <span
          v-if="email.postmark_delivered_at"
          class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800"
          >Delivered</span
        >
        <span
          v-if="email.postmark_bounced_at"
          class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800"
          >Bounced</span
        >
        <span
          v-if="email.postmark_received_at"
          class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
          >Opened</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import { sanitizeRichText } from '../../utilities/sanitization';
import DateUtility from '../../utilities/dates';

export default {
  props: {
    email: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showBody: false,
    };
  },
  methods: {
    ...DateUtility,
    sanitize(html) {
      return sanitizeRichText(html);
    },
  },
};
</script>
